
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/folder/[id]",
      function () {
        return require("private-next-pages/folder/[id]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/folder/[id]"])
      });
    }
  